var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Table',{staticClass:"deal-events-table",attrs:{"recordset":_vm.dealEventItems,"columns":_vm.tableColumns,"responsive":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }